import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#cart'

import { computed, onMounted, onUnmounted, ref } from "vue";
  import SwipeModal from "./SwipeModal.vue";
  import Cart from "./Cart.vue";
  import OrderResult from "./OrderResult.vue";
  import { priceFormat } from "@/helpers/priceFormat";
  import { eventBus } from "@/helpers/eventBus";
  import { IProduct } from "@/models/models";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CartModal',
  setup(__props) {

  const bottomSheetRef = ref<InstanceType<typeof SwipeModal>>();

  const bottomSheetResultRef = ref<InstanceType<typeof SwipeModal>>();

  const isVisible = ref<boolean>(false as boolean);

  const isVisibleResult = ref<boolean>(false as boolean);

  const onOpenCart = async () => {
    isVisible.value = true;
    setTimeout(() => {
      bottomSheetRef.value?.open();
    }, 200);
  };

  const onCloseDetail = () => {
    bottomSheetRef.value?.close();
    setTimeout(() => {
      isVisible.value = false;
    }, 200);
  };

  const onOpenResult = async () => {
    isVisibleResult.value = true;
    onCloseDetail();
    setTimeout(() => {
      bottomSheetResultRef.value?.open();
      basket.value = [];

      localStorage.setItem("basket", JSON.stringify(basket.value));

      eventBus.emit("cart-clear", {});
    }, 200);
  };

  const onCloseResult = () => {
    isVisibleResult.value = false;
  };

  let basket = ref<Array<IProduct>>(JSON.parse(localStorage.getItem("basket") || "[]"));

  const resultPrice = computed(() => {
    let sum = 0;

    basket.value.forEach((item: IProduct) => {
      sum += item.count * item.basePrice;
    });

    return sum;
  });

  const updateCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
  };

  const clerCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
  };

  eventBus.on("cart-updated", updateCart);

  eventBus.on("cart-clear", clerCart);

  onMounted(() => {
    window.addEventListener("storage", updateCart);
  });

  onUnmounted(() => {
    window.removeEventListener("storage", updateCart);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(basket).length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "cart-btn btn btn--green",
          onClick: onOpenCart
        }, [
          _createTextVNode(_toDisplayString(_unref(priceFormat)(resultPrice.value)) + " ", 1),
          _cache[0] || (_cache[0] = _createElementVNode("svg", {
            width: "16",
            height: "16"
          }, [
            _createElementVNode("use", { "xlink:href": _hoisted_1 })
          ], -1))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(SwipeModal, {
      ref_key: "bottomSheetRef",
      ref: bottomSheetRef
    }, {
      default: _withCtx(() => [
        _createVNode(Cart, {
          onOnOpenResult: onOpenResult,
          onOnCloseDetail: onCloseDetail
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, isVisible.value]
    ]),
    _withDirectives(_createVNode(SwipeModal, {
      ref_key: "bottomSheetResultRef",
      ref: bottomSheetResultRef,
      onOnClose: onCloseResult
    }, {
      default: _withCtx(() => [
        _createVNode(OrderResult)
      ]),
      _: 1
    }, 512), [
      [_vShow, isVisibleResult.value]
    ])
  ], 64))
}
}

})